import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
type CounterProps = {
  value: number;
  prefix?: string;
  suffix?: string;
  duration?: number;
};
export function Counter({
  value,
  prefix = '',
  suffix = '',
  duration = 1800
}: CounterProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.round(eased * value));
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, value, duration]);
  return <span ref={ref} data-id="element-30" data-mp="13lhrs65eakr7">
      {prefix}
      {display}
      {suffix}
    </span>;
}